import * as angular from "angular";
import {Group} from "../../models/groups/group.model";
import {StudyProgram} from "../../models/study-program.model";
import {Instructor} from "../../models/instructor.model";

type typeaheadSource = Group | Instructor | StudyProgram;


export class TypeaheadProviderService {
    /* @ngInject */
     constructor() { }

    typeaheadProvider = (input: string, typeaheadSource: typeaheadSource[], 
                        tags: string[], typeaheadPaths: string[]): typeaheadSource[] => {
      return typeaheadSource.filter((source: typeaheadSource) => {
          if (typeaheadPaths.length > 1) {  
              return this.hasSearchPaths(source, input.toLowerCase(), typeaheadPaths); 
          }
          return  !!(this.getPathResult(source, typeaheadPaths[0] as string).toLowerCase().indexOf(input.toLowerCase()) + 1);
      })
      .filter((match: any) => {
          return !tags.some((tag: string) => angular.equals(tag, match));
      });
    };

    private hasSearchPaths(tag: typeaheadSource, value: string, typeaheadPaths: string[]): boolean {
        return (typeaheadPaths as string[]).some((path: string) => {
            let candidate = (this.getPathResult(tag, path) as string).toLowerCase();
            return !!(candidate.indexOf(value) + 1);
        });
    };

    private getPathResult(tag: typeaheadSource, path: string) {
        return path.split(/\./).reduce((result: any, step: string) => {
            if (result) { return result[step]; }
        }, tag);
    };
    
    setTagType = (type: string, assignmentTypes): typeaheadSource[] => {
        switch(type) {
            case "groupAssign":
                return assignmentTypes.assignGroups;
            case "programAssign": 
                return assignmentTypes.assignPrograms;
            case "instructorAssign":
                return assignmentTypes.assignInstructors;
            case "instructor":
                return assignmentTypes.instructors;
            case "program":
                 return assignmentTypes.productGroups.TESTPREP.studyPrograms;
            default:
                return null;
        }
    };
}



/** WEBPACK FOOTER **
 ** ./~/tslint-loader!./app/common/typeahead-provider/typeahead-provider.service.ts
 **/